/* eslint-disable camelcase */
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';

/* Log environment */
let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
console.log('ENVIRONMENT: ', env);

let firebaseConfig = {};

/* Connect to firebase project test (includes demo) */
if (env === 'development' || env === 'test' || env === 'demo') {
	firebaseConfig = {
		apiKey: 'AIzaSyAN0Xsr5YMsoyu00F_7yjZTyoMjT00sj6Q',
		authDomain: 'cgl-diipta-test.firebaseapp.com',
		projectId: 'cgl-diipta-test',
		storageBucket: 'cgl-diipta-test.firebasestorage.app',
		messagingSenderId: '666448089959',
		appId: '1:666448089959:web:c67cd7ce60284aab67d5c2'
	};
}

/* Connect to firebase project production */
if (env === 'production') {
	firebaseConfig = {
		apiKey: 'AIzaSyBSmRK42aj3zTwsrtOnTqWvIfsDPFHWW-0',
		authDomain: 'cgl-diipta-production.firebaseapp.com',
		projectId: 'cgl-diipta-production',
		storageBucket: 'cgl-diipta-production.firebasestorage.app',
		messagingSenderId: '459418700370',
		appId: '1:459418700370:web:235f5662ea66a10706ed8b'
	};
}

/* Initialize firebase */
firebase.initializeApp(firebaseConfig);

export default firebase.firestore;